import { render, staticRenderFns } from "./productInfo.vue?vue&type=template&id=504958f6&scoped=true"
import script from "./productInfo.vue?vue&type=script&lang=js"
export * from "./productInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "504958f6",
  null
  
)

export default component.exports